'use client';

import { AwsRumClientProvider, useInitAwsRum } from '@/app/common/monitoring/aws';
import { ReactNode } from 'react';

interface AwsRumProviderProps {
  children: ReactNode;
  applicationIds: Record<string, string>;
  identityPoolId?: string;
  rumGuestRoleArn?: string;
}

export function AwsRumProvider({
  children,
  applicationIds,
  identityPoolId,
  rumGuestRoleArn,
}: AwsRumProviderProps) {
  const awsRum = useInitAwsRum({
    applicationIds,
    identityPoolId,
    rumGuestRoleArn,
  });

  return <AwsRumClientProvider awsRum={awsRum}>{children}</AwsRumClientProvider>;
}
